export const language: any = {
  title: "Hey! Cooker-Community",
  follow: "Folgen",
  follower: "Follower",
  post_share: "Geteilter Beitrag",
  like_share: "Gefällt mir",
  report: "Verstoß melden",
  delete_post: "Beitrag löschen",
  delete_comment: "Kommentar löschen",
  confirm_report: "Sind Sie sicher, dass dieser Beitrag gegen die Community-Richtlinien verstößt? Wenn die Meldung erfolgreich ist, können Sie diesen Beitrag nicht mehr sehen.",
  confirm_report_comment: "Sind Sie sicher, dass dieser Kommentar gegen die Community-Richtlinien verstößt?",
  toats_report: "Danke für Ihre Meldung. Sie wird überprüft.",
  confirm_delete: "Möchten Sie diesen Beitrag wirklich löschen?",
  confirm_delete_comment: "Möchten Sie diesen Kommentar wirklich löschen?",
  toast_delete: "Erfolgreich gelöscht!",
  text_yes: "Ja",
  text_no: "Nein",
  create: {
    title: "Beitrag verfassen - Hey! Cooker Community",
    content_placeholder: "Geben Sie den Inhalt des Beitrags ein",
    submit: "Jetzt teilen",
    add_image_by_camera: "Mit Kamera aufnehmen",
    add_image_by_gallery: "Foto auswählen",
    add_video_by_camera: "Video aufnehmen",
    add_video_by_gallery: "Video auswählen"
  },
  detail: {
    shared: "Geteilt",
    shared_community: "Foto (Video) wurde mit der Community geteilt"
  },
  follwed: "Gefolgt",
  comment: {
    placeholder: "Bitte geben Sie einen Kommentar ein",
    submit: "Senden",
    nodata: "Hinterlassen Sie hier einen Kommentar und seien Sie der erste Kommentarautor!",
    load_more: "Weitere Kommentare",
    not_login: "Bitte loggen Sie sich ein, um zu kommentieren",
    delete: "Kommentar löschen",
    delete_confirm: "Möchten Sie diesen Kommentar wirklich löschen?",
    delete_success: "Kommentar erfolgreich gelöscht",
    report: "Melden",
    report_confirm: "Sind Sie sicher, dass dieser Kommentar gegen die Community-Richtlinien verstößt?",
    report_success: "Vielen Dank für Ihre Meldung,\nIhre Meldung wird überprüft",
  },
  bottom_navigation: "Gemeinschaft",
  shared_post: "Hat den Beitrag geteilt"
};
